var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":"","color":"info","title":"Editar","to":{ path: `/clientes/${_vm.cliente.matricula}` },"large":_vm.large,"disabled":_vm.lista_itens.length > 0}},[_c('v-icon',[_vm._v("mdi-pencil")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }